/* eslint-disable max-len */
import React from 'react';

export type CopyIconProps = {
  width?: string | number;
  height?: string | number;
  className?: string;
};

export const CopyIcon: React.FC<CopyIconProps> = ({ width = 17, height = 16, className, ...props }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <path
      className="copy-icon-bg"
      d="M13.17 0.75H2.37C1.4753 0.75 0.75 1.42157 0.75 2.25V12.25C0.75 13.0784 1.4753 13.75 2.37 13.75H13.17C14.0647 13.75 14.79 13.0784 14.79 12.25V2.25C14.79 1.42157 14.0647 0.75 13.17 0.75Z"
      fill="currentColor"
      stroke="black"
      strokeWidth="1.5"
    />
    <path
      className="copy-icon-bg"
      d="M4.53011 3.25H15.3299C15.9854 3.25 16.45 3.73325 16.45 4.25V14.25C16.45 14.7667 15.9854 15.25 15.3299 15.25H4.53011C3.87461 15.25 3.40999 14.7667 3.40999 14.25V4.25C3.40999 3.73325 3.87461 3.25 4.53011 3.25Z"
      fill="currentColor"
      stroke="black"
    />
  </svg>
);
